import React from 'react';
import AdminPollPricing from './AdminPollPricing';

/**
 * Assessment Pricing — reuses the AdminPollPricing UI but scopes it to the
 * candidacy assessment poll types (ids starting with `candidacy_`), with
 * adjusted headings and the "Add Poll Type" action hidden.
 *
 * Backend storage stays unified: both pages read/write the same
 * `/api/admin/poll-pricing` endpoint, so saving here preserves all poll
 * pricing entries (only the visible subset is edited at a time).
 */
export default function AdminAssessmentPricing() {
  return <AdminPollPricing category="assessments" />;
}
